module.exports = {
    UserPoolId: "us-east-2_JiPGZ9Loa",
    ClientId: "1hjdbmpjt0sumj7qhg8bml0qph",
    Region: "us-east-2",
    customScope: 'api.ice-ix.net/api',
    domain: 'ice-ix.auth.us-east-2.amazoncognito.com',
    redirectUri: 'https://ice-ix.net/Dashboard',
    signOutRedirectUri: 'https://ice-ix.net',
  };
  